module.exports = __webpack_public_path__ + "static/img/Nic-Naitanui.f0481aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nic-Naitanui.jpg
// module id = kSr0
// module chunks = 0